import { getAwsConfig } from '@npm-client-frontends/shared-utils/environment'
import { env } from '../environments/environment'

export const awsConfig = getAwsConfig(env)
